 <div class="inauguration-card-container">
  <!-- Cloud Icon on Red Triangle -->
  <img src="assets/img/icone-cloud.svg" alt="Cloud" class="cloud-icon">
  
  <div class="inauguration-card">
    <!-- Project Image -->
    <div class="card-project-image" [ngStyle]="{'background-image': imageStyle}" (click)="getSharedProject()">
    </div>

    <!-- Project Name -->
    <div class="card-project-name">
      {{ project?.projectName || ('caravan.projectName' | transloco) }}
    </div>

    <!-- User Info -->
    <div class="user-info-wrapper">
      <div class="user-info-inner">
        <div class="user-icon">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor"/>
          </svg>
          <span class="user-label">{{ "caravan.driver" | transloco }}</span>
        </div>
        <span class="user-name-text">{{ (project?.nickname?.[0] || ('caravan.userName' | transloco)).split(' ')[0] | uppercase }}</span>
      </div>
    </div>

    <!-- Button -->
    <div class="card-button-container">
      <button class="card-view-project-btn" (click)="getSharedProject()">
        {{ "caravan.viewFullProject" | transloco }}
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="currentColor"/>
        </svg>
      </button>
    </div>

    <!-- FT Pilot Logo -->
    <div class="card-footer-logo">
      <img src="assets/img/logo-FTCloud-white.svg" alt="FT Pilot" class="ftcloud-logo">
    </div>
  </div>
 </div>

